import script from "./QModalCompany.vue?vue&type=script&setup=true&lang=js"
export * from "./QModalCompany.vue?vue&type=script&setup=true&lang=js"

import "./QModalCompany.vue?vue&type=style&index=0&id=1e5c5999&scoped=true&lang=scss"

import exportComponent from "/home/signal-frontend-demo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1e5c5999"]])

export default __exports__